

import BrowseTable from "../components/browse-table"

export default function Browse() {
  return (
    <main style={{ padding: "1rem 0" }}>
      <BrowseTable></BrowseTable>
    </main>
  );
}